import { render } from "./QuestDialog10.vue?vue&type=template&id=5b14bfe8"
import script from "./QuestDialog10.vue?vue&type=script&lang=js"
export * from "./QuestDialog10.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questDialogs/QuestDialog10.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b14bfe8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b14bfe8', __exports__)) {
    api.reload('5b14bfe8', __exports__)
  }
  
  module.hot.accept("./QuestDialog10.vue?vue&type=template&id=5b14bfe8", () => {
    api.rerender('5b14bfe8', render)
  })

}


export default __exports__